// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { ReadabilityRepoService } from '@client/app/services/api/readability-repo/readability-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'readability-summary',
    standalone: false,
    template: `
        <page-header
                [icon]="['QA', 'READABILITY'] | monIcons"
            [header]="'Readability Summary' | translate"
                [subHeader]="subheaderTranslation + ' ' + (summary.test | translateReadability) + ')'">
            <page-header-content>
                <div class="row">
                    <div class="col-48 text-right">
                        <filter-button [showFiltersBtn]="showFilters" [(isFiltersOpen)]="isFiltersOpen" class="inline-block text-v-middle">
                        </filter-button>
                        <csv-export-button clsSize="py-2 px-3"
                                           clsMargin="mr-0"
                                           category="readability_pages">
                        </csv-export-button>
                    </div>
                </div>
            </page-header-content>
        </page-header>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="merge-r-16 merge-l-16 merge-t-16 mb-4" *ngIf="isFiltersOpen">
                    <table-filters [(open)]="isFiltersOpen"
                                   [(ngModel)]="filters"
                                   [filters]="availableFilters"
                                   (onChanges)="onFiltersChanges($event)"
                                   name="filters">
                    </table-filters>
                </div>
                <readability-summary-results *ngIf="summary.distribution" [summary]="summary"></readability-summary-results>
            </div>
        </div>

        <div class="row">
            <div class="col-48">
                <div class="card panel-monsido-card">
                    <div class="card-body">
                        <div class="row">
                            <mon-panel-header-next [pHeader]="'Readability by score' | translate" />
                        </div>
                        <mon-spinner [loading]="loading">
                            <readability-summary-score [filterType]="filterType" [summary]="summary"></readability-summary-score>
                        </mon-spinner>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class ReadabilitySummaryComponent implements OnInit {
    summary: any = {};
    isFiltersOpen: boolean = false;
    showFilters: boolean = false;
    filterType: any = null;
    loading: boolean = false;
    subheaderTranslation: string = '';
    filterTypesName: string = '';
    filters: any = {};
    availableFilters: any = {};

    constructor (
        private readabilityRepoService: ReadabilityRepoService,
        private pipeService: PipeService,
        private stateService: StateService,
        private activeFeatures: ActiveFeatureService,
        private translateService: TranslateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    ngOnInit (): void {
        if (!this.pipeService.get('activeFeature')('readability')) {
            this.monUIRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.dashboard');
                },
            );
        }
        this.summary = {};
        this.isFiltersOpen = false;
        this.showFilters = this.activeFeatures.isFeatureActive('table_filters');
        this.filterType = null;
        this.loading = false;
        this.subheaderTranslation = this.translateService.getString('Readability scores across all web pages (based on');
        this.getSummary();
        this.setupFilters();
    }

    getSummary (): void {
        const params = {
            type: this.filterType,
        };
        this.loading = true;
        this.readabilityRepoService.summary(params)
            .then((data: any) => {
                this.summary = data;
                this.summary.plain_distribution = this.summary.distribution;
                this.summary.distribution = Object.keys(this.summary.distribution).map((key: string) => {
                    return { name: key, page_count: this.summary.distribution[key] };
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onFiltersChanges (changes: any): void {
        if (changes[this.filterTypesName].length > 0) {
            this.filters[this.filterTypesName] = [changes[this.filterTypesName][changes[this.filterTypesName].length - 1]];
            this.filterType = this.filters[this.filterTypesName][0].value;
        } else {
            this.filterType = null;
        }
        this.getSummary();
    }

    setupFilters (): void {
        this.filterTypesName = this.translateService.getString('Type');
        this.filters = {};
        this.filters[this.filterTypesName] = [];
        this.availableFilters = {};
        this.availableFilters[this.filterTypesName] = [
            {
                name: this.translateService.getString('HTML'),
                value: 'html',
            },
            {
                name: this.translateService.getString('PDF'),
                value: 'pdf',
            },
            {
                name: this.translateService.getString('Documents'),
                value: 'document',
            },
        ];
    }
}
